<template>
  <form class="contact-form" @submit.prevent="checkForm">
    <!-- prettier-ignore -->
    <div class="form-group" v-bind:class="{'form-group-error': !nameIsValid && this.state.displayFormErrors}">
      <label for="msg-name">Name</label>
      <input type="text" class="form-control" v-model="contactFormData.name" />
      <p>The name field is required.</p>
    </div>
    <!-- prettier-ignore -->
    <div class="form-group" v-bind:class="{'form-group-error': !emailIsValid && this.state.displayFormErrors}">
      <label for="msg-email">Email</label>
      <input type="text" class="form-control" v-model="contactFormData.email" />
      <p>A valid email address is required.</p>
    </div>
    <!-- prettier-ignore -->
    <div class="form-group">
      <label for="msg-company">Company (Optional)</label>
      <input type="text" class="form-control" v-model="contactFormData.company" />
    </div>
    <!-- prettier-ignore -->
    <div class="form-group" v-bind:class="{'form-group-error': !subjectIsValid && this.state.displayFormErrors}">
      <label for="msg-name">Subject</label>
      <!-- prettier-ignore -->
      <input type="text" class="form-control" v-model="contactFormData.subject" />
      <p>The subject field is required.</p>
    </div>
    <!-- prettier-ignore -->
    <div class="form-group" v-bind:class="{'form-group-error': !messageIsValid && this.state.displayFormErrors}">
      <label for="msg-message">Message</label>
      <!-- prettier-ignore -->
      <textarea rows="10" class="form-control" v-model="contactFormData.message"></textarea>
      <p>The message field is required.</p>
    </div>
    <div class="form-result">
      <p class="alert alert-success" v-if="!errors.length && formSuccess">
        Message sent successfully.
      </p>
      <div class="alert alert-error" v-if="errors.length">
        Message failed. Please retry or email me directly at
        <a href="mailto:hi@arimgibson.com">hi@arimgibson.com</a>. <br /><br />
        Note that even if you receive an email,
        <b>your message didn't reach me</b>. <br /><br />
        If you wouldn't mind, please notify me of the following errors:
        <ul>
          <li v-for="(error, idx) in errors" :key="idx">{{ error }}</li>
        </ul>
      </div>
    </div>
    <div class="form-group">
      <button class="btn" type="submit">
        Send
      </button>
    </div>
  </form>
</template>

<script>
// import dbContactForm from "../cloudFirestore";

export default {
  name: "ContactForm",
  data: function () {
    return {
      contactFormData: {
        name: null,
        email: null,
        company: null,
        subject: null,
        message: null,
      },
      state: {
        firebase: false,
        integromat: false,
        displayFormErrors: false,
        displaySubmitErrors: false,
      },
      errors: [],
    };
  },
  computed: {
    nameIsValid() {
      return !!this.contactFormData.name;
    },
    emailIsValid() {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(this.contactFormData.email);
    },
    subjectIsValid() {
      return !!this.contactFormData.subject;
    },
    messageIsValid() {
      return !!this.contactFormData.message;
    },
    formIsValid() {
      return (
        this.nameIsValid &&
        this.emailIsValid &&
        this.subjectIsValid &&
        this.messageIsValid
      );
    },
    formSuccess() {
      return !!this.state.firebase && !!this.state.integromat;
    },
  },
  methods: {
    checkForm: function () {
      if (this.formIsValid) {
        this.submitForm();
      } else {
        this.state.displayFormErrors = true;
      }
    },
    submitForm: function () {
      const { name, email, company, subject, message } = this.contactFormData;
      const payload = { name, email, company, subject, message };
      const url = "https://hook.integromat.com/ro1kajqqrxv12tsxrhq3xhadceq5b283"; // prettier-ignore
      this.errors = [];
      this.state.displaySubmitErrors = false;

      // dbContactForm
      //   .doc(email + " | " + new Date())
      //   .set({
      //     name: name,
      //     email: email,
      //     company: company,
      //     subject: subject,
      //     message: message,
      //   })
      //   .then(() => (this.state.firebase = true))
      //   .catch((err) => {
      //     this.state.displaySubmitErrors = true;
      //     this.errors.push(err);
      //   });

      fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      })
        .then((response) => {
          if (response.ok) {
            this.state.integromat = true;
          }
          if (this.formSuccess) {
            this.resetForm();
          }
        })
        .catch((err) => {
          this.state.displaySubmitErrors = true;
          this.errors.push(err);
        });
    },
    resetForm: function () {
      this.state.displayFormErrors = false;
      this.contactFormData = {
        name: null,
        email: null,
        company: null,
        subject: null,
        message: null,
      };
    },
  },
};
</script>

<style scoped>
.contact-form {
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 360px;
}
.form-group {
  padding: 10px;
}

.form-group p {
  display: none;
}

.form-group-error .form-control {
  border-color: #ff2121;
}

.form-group-error p {
  color: #ff2121;
  display: block;
  text-align: left;
}

.form-control {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

input[type="text"].form-control {
  margin: 8px 0;
  display: inline-block;
}
textarea.form-control {
  resize: none;
}
.btn {
  cursor: pointer;
  padding: 8px 10px;
  outline: none;
  border: none;
  background: #3be249;
  font-size: 16px;
  width: 100%;
  border-radius: 4px;
  text-align: center;
}
.alert {
  padding: 0 10px;
}
.alert-success {
  color: #3be249;
}
.alert-error {
  color: #ff2121;
}
</style>
